/** @format */
import { css } from 'styled-components';

export const styles = css`
    text-align: center;
`;
